/**
 * Addon Content Database - Shared Modal Content
 *
 * Single source of truth for ALL widget modal content.
 * Used by: AccordionWidget, BundlePreviewWidget, and any future widgets.
 *
 * Structure:
 * - modalTitle: Title shown in modal header
 * - whatsIncluded: Array of feature bullet points
 * - whyParentsLoveThis: Array of benefit bullet points
 *
 * @version 1.0.0
 */

(function(window) {
  'use strict';

  // Ensure ProductWidgets namespace exists
  window.ProductWidgets = window.ProductWidgets || {};

  // Export shared addon content database
  window.ProductWidgets.AddonContentDatabase = {
    "number-plate-addon": {
      modalTitle: "Personalised Number Plate",
      whatsIncluded: [
        "Choose from 45 country flag designs to match your child's heritage",
        "Personalised with your child's name (up to 9 characters)",
        "Professional printing on durable, weather-resistant material",
        "Easy to attach - includes mounting hardware and instructions",
        "Matches perfectly with the vehicle's style and colour scheme",
        "Instant digital proof after ordering so you can see exactly how it looks"
      ],
      whyParentsLoveThis: [
        "Helps siblings share without arguments - 'That's MY car!'",
        "Creates a sense of ownership and responsibility",
        "Makes brilliant photos for social media and family albums",
        "Stops mix-ups at playdates when multiple children visit",
        "Becomes a treasured keepsake as they grow older"
      ]
    },
    "upgrade-to-soft-eva-wheels": {
      modalTitle: "EVA Soft Wheels",
      whatsIncluded: [
        "Four premium EVA foam wheels replacing standard plastic wheels",
        "Fits perfectly on your ride-on - no modifications needed",
        "Suitable for all surfaces: grass, concrete, tiles, carpet, and decking",
        "Won't scratch or mark wooden floors or tiles",
        "Maintenance-free design - never needs inflating",
        "Professional installation available (wheels arrive pre-fitted if ordered together)"
      ],
      whyParentsLoveThis: [
        "Dramatically quieter - no more loud plastic clicking on hard floors",
        "Smoother ride means happier children and longer play sessions",
        "Protects your flooring from scratches and scuff marks",
        "Better grip on grass and uneven surfaces means safer outdoor adventures",
        "One less thing to maintain - no punctures or pumping up required"
      ]
    },
    "upgrade-to-padded-leather-style-seat": {
      modalTitle: "Padded Leather-Style Seat",
      whatsIncluded: [
        "Premium leather-effect seat with extra padding for maximum comfort",
        "Water-resistant surface that wipes clean in seconds",
        "Professionally fitted during assembly (or easy DIY installation)",
        "Matches your vehicle's interior styling perfectly",
        "UV-resistant material won't fade in sunlight",
        "Comfortable even on longer rides around the garden"
      ],
      whyParentsLoveThis: [
        "Wipes clean instantly after muddy adventures or spills",
        "Extra padding means children play longer without discomfort",
        "Looks more luxurious - brilliant for gift-giving",
        "Much easier to clean than fabric seats",
        "Stays looking new even after months of use"
      ]
    },
    "upgrade-to-parental-remote-version": {
      modalTitle: "Parental Remote Control",
      whatsIncluded: [
        "2.4GHz remote control with 15-30 metre range",
        "Full directional control - forward, reverse, left, and right",
        "Emergency stop button for instant safety",
        "Override function - you can take control at any moment",
        "Rechargeable remote with USB charging cable included",
        "Easy pairing with your ride-on - setup takes under 2 minutes"
      ],
      whyParentsLoveThis: [
        "Perfect for younger children who aren't confident steering yet",
        "Prevents accidents near driveways, roads, or ponds",
        "Lets you guide them safely whilst they learn to drive",
        "Emergency stop gives instant peace of mind",
        "Gradual handover - start with full control, then let them take over as confidence grows"
      ]
    },
    "personalised-letter": {
      modalTitle: "Personalised Santa Letter",
      whatsIncluded: [
        "A4 premium letter from Santa with your child's name",
        "Mentions their ride-on toy specifically",
        "Beautiful North Pole design and official Santa signature",
        "Printed on high-quality parchment-style paper",
        "Arrives with your ride-on - perfect timing for Christmas",
        "Keepsake envelope included"
      ],
      whyParentsLoveThis: [
        "Adds magical authenticity to the Father Christmas story",
        "Children treasure these letters for years",
        "Makes the gift feel extra special and personal",
        "Perfect for reading aloud on Christmas morning",
        "Included FREE with your order - no extra cost"
      ]
    },
    "personalised-animated-video": {
      modalTitle: "Santa's Magical Visit",
      whatsIncluded: [
        "8 second personalised HD animated video",
        "Santa appears in <strong>YOUR living room</strong>",
        "Features <strong>YOUR child's ride-on toy</strong>",
        "Personal Christmas message with your child's name",
        "Beautiful Disney/Pixar-style animation kids love",
        "Digital download (delivered in 3-5 days) - Next Day available"
      ],
      whyParentsLoveThis: [
        "Charming animated style - just like their favourite movies",
        "Your child's name throughout the entire video",
        "Santa appears in YOUR actual living room",
        "See their face light up when Santa knows their toy choice",
        "A magical keepsake memory for years to come"
      ]
    },
    "riiroo-12-month-ride-on-battery-warranty": {
      modalTitle: "12-Month Battery Warranty",
      whatsIncluded: [
        "One free battery replacement within 12 months",
        "No quibble claims process - fast turnaround",
        "Covers battery failure and degradation",
        "Free replacement battery shipped directly to you",
        "Peace of mind for the most important component",
        "Batteries aren't covered by manufacturer warranty - this fills the gap"
      ],
      whyParentsLoveThis: [
        "Batteries are the #1 failure point on ride-ons",
        "Avoid disappointment on birthdays and Christmas morning",
        "Much cheaper than buying a replacement battery later",
        "No hassle claims - we trust you",
        "Keeps them riding for longer without expensive repairs"
      ]
    },
    "riiroo-extended-warranty": {
      modalTitle: "Extended Warranty",
      whatsIncluded: [
        "Extended 12-month warranty covering all parts",
        "Covers motors, controllers, wiring, and all electronics",
        "Fast claims process with UK-based support team",
        "Replacement parts shipped directly to your door",
        "Expert technical support included",
        "Comprehensive coverage for complete peace of mind"
      ],
      whyParentsLoveThis: [
        "Ride-ons get heavy use - things can go wrong",
        "Protects your investment for years of fun",
        "No stressful repairs or expensive part purchases",
        "UK support team who actually understand the products",
        "One less thing to worry about"
      ]
    },
    "riiroo-ride-on-car-motorbike-quad-dust-and-rain-cover": {
      modalTitle: "All-Weather Cover",
      whatsIncluded: [
        "Protective cover for dust and light rain showers",
        "UV protection prevents fading and plastic degradation",
        "Elastic hem and tie-down straps - stays secure in wind",
        "Fits most ride-on cars, motorbikes, and quads",
        "Perfect for keeping dust off between play sessions",
        "Lightweight and easy to fit"
      ],
      whyParentsLoveThis: [
        "Keeps dust and debris off between play sessions",
        "UV protection extends the life of plastic parts",
        "No more wiping down before every play session",
        "Quick to put on and take off",
        "Much cheaper than replacing sun-damaged plastic parts"
      ]
    },
    "t1-assembly-service": {
      modalTitle: "Professional Assembly",
      whatsIncluded: [
        "Fully assembled by our expert technicians",
        "Complete safety inspection before dispatch",
        "All stickers and decals applied perfectly",
        "Battery charged and tested",
        "Delivered ready to ride - zero setup required",
        "Arrival on the big day - no stressful late-night assembly"
      ],
      whyParentsLoveThis: [
        "No missing screws, wrong parts, or confusing instructions",
        "Saves hours of frustrating assembly time",
        "Professionally assembled means safer and longer-lasting",
        "More time with family, less time with allen keys",
        "Perfect for surprise gifts - ready to reveal immediately"
      ]
    },
    "riiroo-ride-on-assembly-service": {
      modalTitle: "Professional Assembly",
      whatsIncluded: [
        "Fully assembled by our expert technicians",
        "Complete safety inspection before dispatch",
        "All stickers and decals applied perfectly",
        "Battery charged and tested",
        "Delivered ready to ride - zero setup required",
        "Arrival on the big day - no stressful late-night assembly"
      ],
      whyParentsLoveThis: [
        "No missing screws, wrong parts, or confusing instructions",
        "Saves hours of frustrating assembly time",
        "Professionally assembled means safer and longer-lasting",
        "More time with family, less time with allen keys",
        "Perfect for surprise gifts - ready to reveal immediately"
      ]
    },
    "t3-assembly-service": {
      modalTitle: "Premium Assembly",
      whatsIncluded: [
        "Premium assembly for larger, more complex vehicles",
        "Expert technicians with specialised training",
        "Comprehensive safety inspection and testing",
        "All stickers and decals applied perfectly",
        "Battery charged, tested, and conditioned",
        "White-glove delivery - ready to ride immediately"
      ],
      whyParentsLoveThis: [
        "Large ride-ons can take 3-4 hours to assemble yourself",
        "Complex electronics need expert installation",
        "Guaranteed perfect assembly - no second-guessing",
        "Arrives Christmas morning ready to go",
        "Worth every penny for the peace of mind"
      ]
    },
    "riiroo-gift-bow-in-silk-material-perfect-for-ride-on-car-motorbikes-1": {
      modalTitle: "Large Silk Gift Bow",
      whatsIncluded: [
        "Massive premium silk bow - makes a real statement",
        "Available in multiple colours to match any occasion",
        "Reusable - keep it for future celebrations",
        "Easy to attach and remove without marking",
        "Perfect Instagram moment - photos parents treasure",
        "Arrives pre-made - ready to place on the ride-on"
      ],
      whyParentsLoveThis: [
        "The big reveal moment deserves the presentation",
        "Children's faces light up seeing that giant bow",
        "Makes amazing photos and videos to share",
        "Shows how special the gift truly is",
        "Small touch that creates lifelong memories"
      ]
    },
    "riiroo-driving-test-and-license-kit": {
      modalTitle: "Driving Test & License Kit",
      whatsIncluded: [
        "Official RiiRoo driving licence card",
        "Multi-page driving test booklet",
        "Congratulations pass certificate",
        "Stretches their imagination with their first driving test",
        "High-quality printed materials",
        "Makes them feel like a real driver"
      ],
      whyParentsLoveThis: [
        "Adds an extra layer of excitement and responsibility",
        "Great for teaching road safety in a fun way",
        "They'll proudly show everyone their \"licence\"",
        "Creates a memorable experience beyond just the toy",
        "Perfect for role-play and imaginative play"
      ]
    },
    "kids-traffic-lights-signs-bundle": {
      modalTitle: "Traffic Lights & Signs Bundle",
      whatsIncluded: [
        "Working traffic light with red, amber, and green lights",
        "Pedestrian stop and go lights included",
        "5 road signs: stop, zebra crossing, warning, no entry, and traffic signal",
        "Automatic or manual light functionality - choose how to play",
        "Integrated traffic light sounds for realistic play (batteries not included)",
        "High-grade durable plastic - built to last"
      ],
      whyParentsLoveThis: [
        "Turns the garden into a proper driving course",
        "Educational - teaches real road safety through play",
        "Easy to assemble - get playing in minutes",
        "Multiple children can play together with proper rules",
        "Extends the value and fun of the ride-on"
      ]
    },
    "kids-traffic-light": {
      modalTitle: "Traffic Light",
      whatsIncluded: [
        "Working traffic light with red, amber, and green lights",
        "Pedestrian stop and go lights included",
        "Automatic or manual light functionality",
        "Integrated traffic light sounds (batteries not included)",
        "High-grade durable plastic construction",
        "Easy to assemble"
      ],
      whyParentsLoveThis: [
        "Teaches traffic awareness through play",
        "Perfect for backyard driving courses",
        "Encourages imaginative role-play",
        "Realistic sounds add to the fun",
        "Great value standalone option"
      ]
    },
    "kids-ride-on-driving-license": {
      modalTitle: "Driving License",
      whatsIncluded: [
        "Official RiiRoo driving licence card",
        "High-quality printed materials",
        "Space for child's name and photo",
        "Makes them feel like a real driver",
        "Perfect size to fit in pocket or wallet"
      ],
      whyParentsLoveThis: [
        "Adds excitement and responsibility",
        "They'll proudly show everyone their licence",
        "Great for role-play and imaginative play",
        "Affordable way to add extra fun",
        "Becomes a treasured keepsake"
      ]
    }
  };

})(window);
